import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import styles from "./Home.module.scss";

// icon
import { BiCheck, BiX } from "react-icons/bi";
import { FaChevronRight } from "react-icons/fa";
import { GoIssueOpened } from "react-icons/go";

// variants
import variants from "./Variants";

const Row = ({ data, index, handleClick }) => {
  const [isShow, setIsShow] = useState(false);

  const toggle = () => setIsShow(!isShow);

  const isCompleted = () => {
    return data.LastRunStatusScraper === "Success";
  };

  const isNegative = () => {
    return Number(data.PercentageChangeinRecords) < 0;
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 0.1 * index }}
    >
      <div className={`${styles.row}`} onClick={() => handleClick(data)}>
        {/* <span
          className={`${styles.complete} ${
            isCompleted() ? styles.completed : ""
          }`}
        >
          <span>
            <BiCheck />
          </span>
        </span> */}
        <span
          className={`${styles.source} ${isCompleted() ? styles.active : ""}`}
        >
          <span className={styles.label}>{data.Source || "NULL"}</span>
          <motion.span
            initial={false}
            animate={{ rotate: !isShow ? "0deg" : "90deg" }}
            transition={{ duration: 0.2 }}
            className={styles.icon}
          >
            <FaChevronRight />
          </motion.span>
        </span>
        <span className={styles.affliate}>
          {data.IsAffliate === "1" ? (
            <BiCheck color="#27ae60" />
          ) : (
            <BiX color="#eb5757" />
          )}
        </span>
        <span>
          {data.DataIssues !== "" ? <GoIssueOpened color="#eb5757" /> : null}
        </span>
        <span>{data.LastSuccessScraper || ""}</span>
        <span>{data.LastRunStatusScraper || ""}</span>
        <span>{data.LastSuccessProcess || ""}</span>
        <span>{data.LastRunStatusProcess || ""}</span>
        <span>{data.ScrapeRecords || ""}</span>
        <span>{data.ProcessedRecords || ""}</span>
        <span
          className={`${styles.change} ${isNegative() ? styles.negative : ""}`}
        >
          {!isNegative() && "+"}
          {data.PercentageChangeinRecords !== ""
            ? data.PercentageChangeinRecords
            : "-"}
          %
        </span>
        <span>{data.LogDate || ""}</span>
      </div>
      <AnimatePresence>
        {isShow && (
          <motion.ul
            variants={variants.list}
            initial="hidden"
            animate="show"
            exit="exit"
            className={styles.detail}
          >
            {/* {data.list?.map((item, i) => (
              <motion.li key={i} variants={variants.item}>
                {item}
              </motion.li>
            ))} */}
            <motion.li variants={variants.item}>{data.DataIssues}</motion.li>
          </motion.ul>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default Row;
